import {
  resolvePositionUnderlying,
  type JsonModalDocument,
  type Position,
  type RelatedEntitiesConfig,
} from '@talos/kyoko';
import { UnifiedPosition } from './Unified/UnifiedPosition';

export function getPositionsRelatedEntitiesConfig(includeSedol = false): RelatedEntitiesConfig<Position> {
  return {
    symbolSources: [
      { id: 'Asset', title: 'Asset', getSymbol: (row: Position) => row.Asset },
      {
        id: 'MarkPriceCurrency',
        title: 'Quote Currency',
        getSymbol: (row: Position) => row.MarkPriceCurrency,
        lookup: 'currency',
        optional: true,
      },
      {
        id: 'underlying',
        title: 'Underlying',
        getSymbol: (row: Position, maps) => {
          const underlying =
            row instanceof UnifiedPosition && row.underlying.trim() !== ''
              ? row.underlying
              : resolvePositionUnderlying({
                  asset: row.Asset,
                  assetType: row.AssetType,
                  securitiesBySymbol: maps.securitiesBySymbol,
                });

          return underlying === row.Asset ? undefined : underlying;
        },
        optional: true,
      },
    ],
    feedObjects: getPositionsFeedObjects,
    includeSedol,
  };
}

export function getPositionsFeedObjects(row: Position): JsonModalDocument[] {
  if (!(row instanceof UnifiedPosition)) {
    return [];
  }

  return [
    {
      id: 'position',
      title: 'Position',
      value: row.websocketPosition,
      emptyMessage: `No Position for ${row.Asset}`,
    },
    {
      id: 'balance',
      title: 'Balance',
      value: row.websocketBalance,
      emptyMessage: `No Balance for ${row.Asset}`,
    },
  ];
}
